import { render, staticRenderFns } from "./Contragents.vue?vue&type=template&id=3ac51a20&"
import script from "./Contragents.vue?vue&type=script&lang=js&"
export * from "./Contragents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports